module.exports = __webpack_public_path__ + "media/images/navbar/dropdown_menu/connect-cff30181239ac288992bd6b13dd1fc57.svg";